import * as THREE from 'three';
// @ts-ignore
import gridVert from '../Shaders/gridBackground/vertex.glsl';
// @ts-ignore
import gridFrag from '../Shaders/gridBackground/fragment.glsl';
function hexToVec3(hex) {
    const c = new THREE.Color(hex);
    return new THREE.Vector3(c.r, c.g, c.b);
}
export default class GridBackground {
    constructor(application, config) {
        this.application = application;
        this.config = config;
        this.uniforms = {
            u_resolution: { value: new THREE.Vector2(1, 1) },
            u_time: { value: 0 },
            u_mousePx: { value: new THREE.Vector2(0, 0) },
            u_baseColor: { value: hexToVec3(config.baseColor) },
            u_lineColor: { value: hexToVec3(config.lineColor) },
            u_lineOpacity: { value: config.lineOpacity },
            u_floorRows: { value: config.floorRows },
            u_wallColumns: { value: config.wallColumns },
            u_floorStrength: { value: config.floorStrength },
            u_blinkSpeed: { value: config.blinkSpeed },
            u_blinkIntensity: { value: config.blinkIntensity },
            u_blinkCellSize: { value: config.blinkCellSize },
            u_mouseRadiusPx: { value: config.mouseRadiusPx },
            u_mouseIntensity: { value: config.mouseIntensity },
        };
        const material = new THREE.ShaderMaterial({
            vertexShader: gridVert,
            fragmentShader: gridFrag,
            uniforms: this.uniforms,
            depthTest: true,
            depthWrite: true,
        });
        this.mesh = new THREE.Mesh(new THREE.PlaneGeometry(10000, 10000), material);
        this.mesh.renderOrder = -1000;
        this.mesh.frustumCulled = false;
        this.mesh.castShadow = false;
        this.mesh.receiveShadow = false;
        this.application.scene.add(this.mesh);
    }
    update() {
        const { camera, mouse, sizes } = this.application;
        this.mesh.position.copy(camera.instance.position);
        this.mesh.quaternion.copy(camera.instance.quaternion);
        this.uniforms.u_time.value = this.application.time.current;
        const dpr = Math.min(sizes.pixelRatio, 2);
        this.uniforms.u_resolution.value.set(sizes.width * dpr, sizes.height * dpr);
        this.uniforms.u_mousePx.value.set(mouse.x * dpr, (sizes.height - mouse.y) * dpr);
        this.uniforms.u_mouseRadiusPx.value = this.config.mouseRadiusPx * dpr;
    }
}
